#import "../fragments/newsletter-engagement-stats-fragment.graphql"

query GetNewsletterEngagementStats($newsletterId: ID!) {
    newsletter(id: $newsletterId) {
        ...NewsletterEngagementStats
    }
}
